import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatSnackBar
} from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { OrderService } from '../../../services/order/order.service';
import { TripService } from '../../../services/trip/trip.service';
import 'rxjs/add/observable/of';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MessagesService } from '../../../services/messages/messages.service';
import * as _ from "lodash";
import { UploadfileService } from '../../../services/uploadfile/uploadfile.service';
import { OrderDetailsAndEditOrderComponent } from '../orderdetailsandeditorder/orderdetailsandeditorder.component';
import { TokenStorage } from '../../../auth/token.storage';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ChangeStatusDialogConfirm } from '../../admin/admin.component';
import { AddpickupComponent } from '../../addpickup/addpickup.component';




export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-createtriptable',
  templateUrl: './createtriptable.component.html',
  styleUrls: ['./createtriptable.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class CreatetriptableComponent implements OnInit {

  columnsToDisplay = [
    'invoice',
    'dispatchDate',
    'zone',
    'origin',
    'deliveryStore',
    'receiverDetails',
    'packageDetails',
    'productQuantity',
    'editOrder',
    'action',
  ];
  OrdersDataArray = new MatTableDataSource;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  selectedOrdersDataArray: Array<any> = [];
  zones = [];
  //selectedValue: string = "nozone"; // selected zone for filter date
  selectedValue = []
  orders: any;
  showSpinner: boolean = false;

  //if zone is filtered assgin filtered data to new array for date filtering
  isZoneFiltered: boolean = false;
  //if date is filtered assgin filtered data to new array for zone filtering
  isDateFiltered: boolean = false;
  orderDataArrayForCheck = [];

  daterRangevalue: any;
  options: NgxDateRangePickerOptions;

  fromDate: any;
  toDate: any;
  prevFromDate: any;
  prevTodate: any;
  prevZone = [];
  page: number = 0;
  totalRecords: number;
  typeOfOrder: string;
  pageSize: number = 25;
  isFileUploading: boolean = false;
  fileName: any;
  isZoneOfOriginAddress: boolean = false;
  subscription: Subscription;
  isPageAllSelected = [];
  isAllSelected: boolean = false;
  isTenantDiag: boolean = false;
  isFiltered: boolean = false;
  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    public orderService: OrderService,
    public tripService: TripService,
    private router: Router,
    public snackBar: MatSnackBar,
    private messagesService: MessagesService,
    private uploadService: UploadfileService,
    private token: TokenStorage
  ) { }

  ngOnInit() {
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test')
      this.isZoneOfOriginAddress = true;
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.setDatePickerToCurrentDate();

    this.findSelectedDateOrders();
    this.typeOfOrder = 'ORDER_STATE_UNPLANNED';

    this.subscription = this.uploadService.event.subscribe(() => {
      this.isFileUploading = false;
    });

    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


  /*  sortByZone() {
     console.log(this.selectedValue);
     this.isZoneFiltered = true;
     this.sortByDate();
   } */

  sortByZone() {
    this.prevZone = this.selectedValue;
    let newres = [];
    for (let i = 0; i < this.orders.length; i++) {
      let custZone;
      if (this.orders[i].orderInfo.destinationAddress)
        custZone = this.orders[i].orderInfo.destinationAddress.zone;
      this.selectedValue.forEach(selectedZone => {
        if (custZone === selectedZone) {
          newres.push(this.orders[i]);
        }
        this.OrdersDataArray.data = newres;
        this.orderDataArrayForCheck = newres;
        let selOrder = this.selectedOrdersDataArray;

        /*this filters selected orders that is ticked orders so that when user
         clicks next or prev button the selected order won't loss*/
        this.orderDataArrayForCheck.filter(r => {
          selOrder.forEach(l => {
            if (l.orderUniqueId === r.orderInfo.orderUniqueId) {
              r.isChecked = true;
            }
          });
        });
        this.totalRecords = newres.length;
        if (this.selectedOrdersDataArray.length < newres.length)
          this.isAllSelected = false;
      });
    }
    if (this.selectedValue.length <= 0) {
      this.OrdersDataArray.data = this.orders;
      this.orderDataArrayForCheck = this.orders;
      let selOrder = this.selectedOrdersDataArray;

      /*this filters selected orders that is ticked orders so that when user
       clicks next or prev button the selected order won't loss*/
      this.orderDataArrayForCheck.filter(r => {
        selOrder.forEach(l => {
          if (l.orderUniqueId === r.orderInfo.orderUniqueId) {
            r.isChecked = true;
          }
        });
      });
      this.totalRecords = this.orders.length;

    }
    if (this.selectedOrdersDataArray.length < this.orders.length)
      this.isAllSelected = false;

    this.checkAllOrdersAreAlreadySelectedFromFilter();
  }
  sortByDate() {
    if (this.isDateFiltered && this.page > 0) {
      this.page = 0;
      this.paginator.pageIndex = 0;
    }
    if (this.selectedValue && !this.daterRangevalue) {
      console.log(this.daterRangevalue, this.selectedValue, this.prevZone);
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.findSelectedDateOrders();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
      this.prevZone = this.selectedValue;
    }

    else if (this.daterRangevalue) {
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);

      //call the function only if todate or fromdate or zone value changes 
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate || (this.selectedValue != this.prevZone && this.selectedValue.length != 0)) {
        console.log(this.daterRangevalue, this.selectedValue, this.prevZone);
        this.ngUnsubscribe.next();
        this.isDateFiltered = true;
        this.findSelectedDateOrders();
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
        this.prevZone = this.selectedValue;
      }
    }
  }



  findSelectedDateOrders() {
    console.log(this.fromDate);
    this.getData('ORDER_STATE_UNPLANNED', this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(unplannedOrderList => {
      if (unplannedOrderList.content.length === 0) {
        this.openSnackBar("Orders not found");
        this.OrdersDataArray.data = [];
        this.orderDataArrayForCheck = [];
        this.selectedValue = [];
        this.totalRecords = 0;
        this.page = 0;
        this.paginator.pageIndex = 0;
      }
      else {
        this.zones = [];
        console.log(unplannedOrderList);
        if (this.isPageAllSelected.length == 0)
          for (let i = 0; i < unplannedOrderList.totalPages; i++) {
            this.isPageAllSelected.push(0);
          }
        /*adding ischecked to each order object for 
        selection of order if page changes selected order should remain selected*/

        unplannedOrderList.content.forEach(function (obj) { obj.isChecked = false; });
        unplannedOrderList.content.forEach(order => {
          if (order.orderInfo.destinationAddress && order.orderInfo.destinationAddress.zone)
            this.zones.push(order.orderInfo.destinationAddress.zone);
        });

        //find unique zone names
        this.zones = this.zones.filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        })

        this.orders = unplannedOrderList.content;
        this.OrdersDataArray.data = unplannedOrderList.content;

        //this array is used to check whether order is selected for plan or not
        this.orderDataArrayForCheck = unplannedOrderList.content;
        this.totalRecords = unplannedOrderList.totalElements;
        let selOrder = this.selectedOrdersDataArray;

        //if orders are more than already selected orders then isAllselected is false
        if (this.selectedOrdersDataArray.length < this.orders.length)
          this.isAllSelected = false;

        /*this filters selected orders that is ticked orders so that when user
       clicks next or prev button the selected order won't loss*/
        this.orderDataArrayForCheck.filter(r => {
          selOrder.forEach(l => {
            if (l.orderUniqueId === r.orderInfo.orderUniqueId) {
              r.isChecked = true;
            }
          });
        });
        console.log("All Orders from selected  Date Filter", this.OrdersDataArray.data);

      }

      this.OrdersDataArray.paginator = this.paginator;
      if (this.selectedValue.length != 0) {
        this.isZoneFiltered = true;
        this.sortByZone();
      }

      this.checkAllOrdersAreAlreadySelectedFromFilter();
    });
  }

  clearAllFilter() {
    console.log('clear filter');
    this.isDateFiltered = false;
    this.isZoneFiltered = false;
    this.selectedValue = [];
    this.setDatePickerToCurrentDate();
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.page = 0;
    this.paginator.pageIndex = 0;
    // this.selectedOrdersDataArray = [];
    this.findSelectedDateOrders();
  }

  setDatePickerToCurrentDate() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
  }

  openSnackBar(message) {
    this.snackBar.open(message, 'X', {
      duration: 1000,
      panelClass: ['extraClasses']
    })
  }


  createTrip() {
    console.log(this.selectedOrdersDataArray);
    if (this.selectedOrdersDataArray.length != 0) {
      this.showSpinner = true;
      this.tripService.createTrip(this.selectedOrdersDataArray).subscribe(res => {
        this.showSpinner = false;
        console.log(res.Result);
        this.messagesService.sendMessage(res.Result);
        this.router.navigate(['/scheduling/edittrips']).then(res => {
          console.log(res);
        }, Error => {
          console.log(Error);
        })
      }, Error => {
        this.router.navigate(['/scheduling/edittrips']).then(res => {
          console.log(res);
        }, Error => {
          console.log(Error);
        })
        console.log(Error);
      });
    } else {

      this.snackBar.open("Please select at least one order to create a trip", 'ok', {
        duration: 2000,
      });

    }


  }


  prepareToSend(order, Event) {
    let oid = order.orderInfo.orderUniqueId;
    let foundOrder = this.orderDataArrayForCheck.find(pl => pl.orderInfo.orderUniqueId === oid);
    if (Event.checked) {
      let index = this.orderDataArrayForCheck.indexOf(foundOrder);
      this.orderDataArrayForCheck[index].isChecked = true;
      this.selectedOrdersDataArray.push(order.orderInfo);
    } else if (!Event.checked) {
      if (this.isPageAllSelected[this.page] == true) {
        this.isAllSelected = false;
        this.isPageAllSelected[this.page] = false;
      }
      let index = this.orderDataArrayForCheck.indexOf(foundOrder);
      let removeIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId === order.orderInfo.orderUniqueId);
      //console.log('remove',removeIndex);
      this.orderDataArrayForCheck[index].isChecked = false;
      this.selectedOrdersDataArray.splice(removeIndex, 1);
    }
    console.log("Selected Orders To Create Plan", this.selectedOrdersDataArray);
    this.OrdersDataArray.data = this.orderDataArrayForCheck;
    this.checkAllOrdersAreAlreadySelectedFromFilter();

  }


  checkAllOrdersAreAlreadySelectedFromFilter() {
    for (let i = 0; i < this.orderDataArrayForCheck.length; i++) {
      let findOrder = this.selectedOrdersDataArray.findIndex(sel => sel.orderUniqueId === this.orderDataArrayForCheck[i].orderInfo.orderUniqueId);
      if (findOrder == -1) {
        this.isAllSelected = false;
        break;
      }
      else {
        this.isAllSelected = true;
      }
    }
  }


  getData(type, from, to) {
    return this.orderService.getAllOrdersByTypesDateRange(type, -1, from, to, 'nozone');

  }


  pageChanged(event) {
    this.page = event.pageIndex;
    this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
    this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
    this.findSelectedDateOrders();
  }



  submitFile(fileEvent) {
    debugger; 
    if (fileEvent) {
      
      console.log(fileEvent.target.files[0]);
      this.isFileUploading = true;
      if (fileEvent.target.files.length > 0) {
        const file: File = fileEvent.target.files[0];
         
        // this.uploadService.uploadExcelFile(file);
        if (this.token.getTenant() == 'kohinoor-reta-prod' || this.token.getTenant() == 'kohinoor-reta-test') {// Arjun
          
         this.uploadService.uploadOrderExcelFile_WithoutS3(file);
        }else{
          this.uploadService.uploadExcelFile(file);
        }
      }
    }
  }

  selectAll(event) {
    if (event.checked) {
      this.isPageAllSelected[this.page] = true;
      this.isAllSelected = true;
      this.orderDataArrayForCheck.forEach(function (obj) { obj.isChecked = true; });
      this.OrdersDataArray.data = this.orderDataArrayForCheck;
      this.orderDataArrayForCheck.forEach(order => {
        //remove order if already exist
        let removeIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId === order.orderInfo.orderUniqueId);
        if (removeIndex != -1) {
          this.selectedOrdersDataArray.splice(removeIndex, 1);
        }
        this.selectedOrdersDataArray.push(order.orderInfo);
      });
    }
    else {
      this.isPageAllSelected[this.page] = false;
      this.isAllSelected = false;
      this.orderDataArrayForCheck.forEach(function (obj) { obj.isChecked = false; });

      //remove unselected orders from already selected orders
      this.orderDataArrayForCheck.forEach(order => {
        let removeIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId === order.orderInfo.orderUniqueId);
        this.selectedOrdersDataArray.splice(removeIndex, 1);
      });
      this.OrdersDataArray.data = this.orderDataArrayForCheck;
    }
    console.log("Selected Orders To Create Plan", this.selectedOrdersDataArray);
  }


  EditOrderDetails(data) {
    let editDialog = this.dialog.open(OrderDetailsAndEditOrderComponent, {
      width: '800px',
      data: { data: data }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      if (result) {
        this.findSelectedDateOrders();
      }
    });
  }


  deliveryDateChange(event: MatDatepickerInputEvent<Date>, order) {
    console.log(event.value);
    const dialogRef = this.dialog.open(ChangeStatusDialogConfirm, {
      width: '300px',
      data: 'dateChange'
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let date = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd')
        let getDate = date + 'T05:30:00';
        delete order.isChecked;
        order.orderInfo.deliveryETADateTime = getDate;
        console.log(order);
        this.orderService.orderUpdate(order).subscribe(res => {
          console.log(res);
        }, Error => {
          console.log(Error);
        });
      }
    });
  }

  addPickUp() {
    const dgRef = this.dialog.open(AddpickupComponent, {
      width: '65vw',
      height: '75vh',
      maxHeight: "90vh",
    });
    dgRef.updatePosition({
      top: '64px', right: '10%',
    });
    dgRef.afterClosed().subscribe(result => {
      if (result) {
        this.findSelectedDateOrders();
      }
    });
  }

  applyFilter(filterValue: string) {
    this.OrdersDataArray.filter = filterValue.trim().toLowerCase();
    this.OrdersDataArray.filterPredicate = (data: any, filter: string) => {
      let isInvoice = false;
      if (data) {
        if (data.orderInfo) {
          if (data.orderInfo.orderInvoiceNumber) {
            isInvoice = data.orderInfo.orderInvoiceNumber.toString().toLowerCase().indexOf(filter) != -1;
          }
        }
      }
      return isInvoice;
    };
    console.log(this.OrdersDataArray.filteredData)
    if (this.OrdersDataArray.filteredData.length > 0 && this.OrdersDataArray.filteredData.length != this.OrdersDataArray.data.length) {
      this.isFiltered = true;
    }
    else {
      this.isFiltered = false;
    }
  }

}



export interface NgxDateRangePickerOptions {
  theme: 'default' | 'green' | 'teal' | 'cyan' | 'grape' | 'red' | 'gray';
  range?: string;
  locale?: string;
  labels: string[];
  menu: null;
  dateFormat: string;
  outputFormat: string;
  startOfWeek: number;
  outputType?: 'string' | 'object';
  date?: NgxDateRangePickerDates;
}

export interface NgxDateRangePickerDates {
  from: {
    year: number,
    month: number,
    day: number
  }
  to: {
    year: number,
    month: number,
    day: number
  }
}
